module.exports = __webpack_public_path__ + "img/in-work1.e24d6a5e.gif";